import { render, staticRenderFns } from "./AttachmentsListing.vue?vue&type=template&id=5e2bfa5e"
import script from "./AttachmentsListing.vue?vue&type=script&lang=js"
export * from "./AttachmentsListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports